import React from "react";
import LangToggle from "./LangToggle";
import { SunIcon, MoonIcon } from "./Icons";
import useTheme from "../useTheme";
import { useLang } from "../LangContext";

export default function AuthControls() {
  const [theme, toggleTheme] = useTheme();
  const { t } = useLang();
  return (
    <div className="auth-controls">
      <LangToggle />
      <button
        type="button"
        className="theme-toggle"
        aria-label={theme === "dark" ? t.switchToLight : t.switchToDark}
        onClick={toggleTheme}
      >
        {theme === "dark" ? <SunIcon /> : <MoonIcon />}
      </button>
    </div>
  );
}
